import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { BrowserRouter, Switch, Redirect, Route } from "react-router-dom";
import { Login, Registration, Profile, Usermanagement, ForgotPassword } from './components/IAM'
import { MainLayout } from './components/MainLayout'
import { RSSIDeeplink } from "./components/RSSIDeepLink"
import { HomePage } from './components/Layouts'
import { LoadingPage, UnapprovedUser, LockedUser } from "./components/common";
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import PersonIcon from '@material-ui/icons/Person';
import TuneIcon from '@material-ui/icons/Tune';
import DashboardIcon from '@material-ui/icons/Dashboard';
import { IAMAction } from './actions'
import SessionTimeoutWrapper from "./components/common/SessionTimeoutWrapper"

const App = () => {
    const dispatch = useDispatch()
    const profile = useSelector((state) => state.iam.profile)

    React.useEffect(() => {
        IAMAction.autologin(dispatch)
        IAMAction.getAppConfig(dispatch)
    }, [])

    const pages = [
        [
            { pgid: "homepage", title: "Home Page", href: ["/homepage"], icon: <DashboardIcon color="disabled" />, component: HomePage },
        ],
        [
            { pgid: "usermanagement", title: "User Management", href: ["/usermanagement"], icon: <TuneIcon color="disabled" />, component: Usermanagement },
            { pgid: "profile", title: "Profile", href: ["/profile"], icon: <PersonIcon color="disabled" />, component: Profile },
        ],
        [],
        [
            { pgid: "login", title: "Login", href: ["/login"], icon: <PowerSettingsNewIcon />, component: Login },
            { pgid: "registration", title: "Registration", href: ["/registration"], icon: <PowerSettingsNewIcon />, component: Registration },
            { pgid: "forgotpassword", title: "Forgot Password", href: ["/forgotpassword"], icon: <PowerSettingsNewIcon />, component: ForgotPassword },
        ]
    ]

    console.log(profile)

    return (
        <BrowserRouter>
            <Switch>
                <Redirect exact from="/" to="/homepage" />
                <Route key='login-main' component={() => <Login profile={profile} />} path="/login" />
                <Route key='registration-main' component={() => <Registration profile={profile} />} path="/registration" />
                <Route key='forgotpassword-main' component={() => <ForgotPassword profile={profile} />} path="/forgotpassword" />
                <Route key='rssi-deeplink' component={() => <RSSIDeeplink />} path="/rssi" />
                {
                    pages.flat().map((page) => (
                        <Route exact key={page.pgid} path={page.href}
                            component={
                                () => profile.status === 'LOGGED_IN' ? (
                                    profile.force_password_reset ? (
                                        <SessionTimeoutWrapper><MainLayout profile={profile} pages={pages} component={Profile} /></SessionTimeoutWrapper>
                                    ) : profile.approved === 3 && profile.islocked < 3 ? (
                                        <SessionTimeoutWrapper><MainLayout profile={profile} pages={pages} component={page.component} /></SessionTimeoutWrapper>
                                    ) : (
                                        null
                                    )
                                ) : profile.status === 'WORKING' ? (
                                    <LoadingPage />
                                ) : (
                                    <Redirect push to={{ pathname: "/login" }} />
                                )
                            }
                        />
                    ))
                }
            </Switch>
        </BrowserRouter>
    )
}

export default App;
